@for (option of options(); track option) {
	<button class="optie" [class.is-selected]="value() === option" (click)="select(option)" [class.small]="small()">
		{{ labelFunction()(option) }}
	</button>
}
